import React from 'react';
import ClientForm from "../../components/Client/ClientForm";

export const CreateClient: React.FC = () => {
  return <ClientForm mode="create" />;
};

export default CreateClient;